export default __webpack_public_path__ + "static/assets/c50860fc8c66731a66ce368e14283b75.jpg";